import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;

  font-family: ${Theme.fontFamily.PRIMARY};

  background: ${Theme.pallete.PRIMARY};

  color: ${Theme.fontFamily.SECONDARY};
`
